import React from "react"
import PropTypes from "prop-types"
import {Button} from "antd"
import classNames from "classnames"
import {Icon} from "components/Icons"
import styles from "../ResponsesTable.module.css"

export default function ExpandRowItem(props) {
    const {data, open, setOpen} = props
    if (!data.users) return null

    return open ? (
        <Button
            className={styles.expandIconBtn}
            onClick={() => setOpen(!open)}
            icon={<Icon icon="ARROW_DOWN" className={styles.expandIcon} color="#1e90ff" />}
        />
    ) : (
        <Button
            className={styles.expandIconBtn}
            onClick={() => setOpen(!open)}
            icon={<Icon icon="ARROW_RIGHT" className={styles.expandIcon} color="#1e90ff" />}
        />
    )
}

ExpandRowItem.propTypes = {
    data: PropTypes.object,
    open: PropTypes.bool,
    setOpen: PropTypes.func
}
